export default function CCertificate() {
  return <h2>C Certificate</h2>;
}
